export default {
  ACCEPTED: 'ACCEPTED',
  PENDING: 'PENDING',
} as const
